module.exports = __webpack_public_path__ + "static/media/MBXO3857.1801f95b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/MBXO3857.JPG
// module id = 321
// module chunks = 0